import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { ReviewViewModel } from '../../models';
import { TruncatePipe } from '../../common-components/pipes/truncate.pipe';
import { NewlineToBrPipe } from '../../shared-components/pipes/newline-to-br.pipe';
import { RouterLink } from '@angular/router';


@Component({
    selector: 'review-display',
    templateUrl: './review-display.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink, NewlineToBrPipe, TruncatePipe]
})


export class ReviewDisplayComponent {
  @Input() maxTextLength: number;
  @Input() review: ReviewViewModel;
  @Input() showTitle = true;
  @Output() showMore = new EventEmitter<ReviewViewModel>();
}
